import { useReducer } from 'react';

export type UseStepper = [StepperState, StepperDispatch];

export interface StepperDispatch {
  onStepComplete: (step: number) => void;
  onStepIncomplete: (step: number) => void;
  setNextStep: (step: number) => void;
  setActiveStep: (step: number) => void;
}
export interface StepperState {
  completedSteps: Set<number>;
  activeStep: number;
}
type Action =
  | { type: 'STEP_COMPLETE'; payload: number }
  | { type: 'STEP_INCOMPLETE'; payload: number }
  | { type: 'SET_NEXT_STEP'; payload: number }
  | { type: 'SET_ACTIVE_STEP'; payload: number };

const getDefaultState = (): StepperState => ({
  completedSteps: new Set([]),
  activeStep: 0
});

const stepperReducer = (state: StepperState, action: Action): StepperState => {
  switch (action.type) {
    case 'STEP_COMPLETE':
      return { ...state, completedSteps: state.completedSteps.add(action.payload) };
    case 'STEP_INCOMPLETE':
      state.completedSteps.delete(action.payload);
      return { ...state, completedSteps: state.completedSteps };
    case 'SET_NEXT_STEP':
      return { ...state, activeStep: state.activeStep + action.payload };
    case 'SET_ACTIVE_STEP':
      return { ...state, activeStep: action.payload };
    default:
      return getDefaultState();
  }
};

const useStepper = (): UseStepper => {
  const [state, dispatch] = useReducer<React.Reducer<StepperState, Action>>(
    stepperReducer,
    getDefaultState()
  );

  const onStepComplete = (step: number): void => dispatch({ type: 'STEP_COMPLETE', payload: step });

  const onStepIncomplete = (step: number): void =>
    dispatch({ type: 'STEP_INCOMPLETE', payload: step });

  // 1 or -1
  const setNextStep = (stepForwardsOrBackwards: number): void =>
    dispatch({ type: 'SET_NEXT_STEP', payload: stepForwardsOrBackwards });

  const setActiveStep = (step: number): void =>
    dispatch({ type: 'SET_ACTIVE_STEP', payload: step });

  return [
    state,
    {
      onStepComplete,
      onStepIncomplete,
      setNextStep,
      setActiveStep
    }
  ];
};

export { useStepper };
